import { Box, Button, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Formik } from 'formik';

import { InputBaseField } from 'src/components/common/form/FormInput';
import { Flex } from 'src/components/Flex';
import { FileUploadSelect } from 'src/components/FormikComponents';
import ColorPicker from 'src/components/FormikComponents/ColorPicker';
import { LogoUploadModalContentProps } from 'src/pages/ViewPartnerPage/types';

import { validationSchema } from './validationSchema';

const LogoUploadModalContent = ({
    handleEditModalClose,
    handleEdit,
    enableBranding,
    initialValues,
}: LogoUploadModalContentProps) => {
    return (
        <Box>
            <Formik
                initialValues={initialValues}
                onSubmit={(data) => {
                    handleEdit({
                        logo: data.logo,
                        useBranding: data.useBranding,
                        brandingColour: data.brandingColour,
                        useCustomTerms: data.useCustomTerms,
                        termAndConditions: data.termAndConditions,
                    });
                    handleEditModalClose();
                }}
                validationSchema={validationSchema}
            >
                {({ submitForm, values, setFieldValue, isValid }) => {
                    return (
                        <Box>
                            <FileUploadSelect
                                name="logo"
                                label="Upload File"
                                maxFileSize={15000000}
                                landscapeImagesOnly
                                isNonSensitive
                            />

                            {enableBranding && (
                                <>
                                    <FormControlLabel
                                        control={
                                            <Flex sx={{ cursor: 'help' }}>
                                                <Tooltip
                                                    title={
                                                        'Select this option only for strategic brands/partners that should not include NPI branding'
                                                    }
                                                    placement="bottom"
                                                >
                                                    <Checkbox
                                                        checked={values.useBranding}
                                                        onChange={(e) => {
                                                            return setFieldValue(
                                                                'useBranding',
                                                                e.target.checked
                                                            );
                                                        }}
                                                        color="primary"
                                                        data-testid="branding-checkbox"
                                                    />
                                                </Tooltip>
                                            </Flex>
                                        }
                                        label="Use branded merchant communications?"
                                        data-testid="branding-label"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Flex sx={{ cursor: 'help' }}>
                                                <Checkbox
                                                    checked={values.useCustomTerms}
                                                    onChange={(e) => {
                                                        return setFieldValue(
                                                            'useCustomTerms',
                                                            e.target.checked
                                                        );
                                                    }}
                                                    color="primary"
                                                    data-testid="branding-terms-checkbox"
                                                />
                                            </Flex>
                                        }
                                        label="Use branded Terms and Conditions?"
                                        data-testid="branding-label-terms"
                                    />
                                </>
                            )}

                            {values.useBranding && (
                                <ColorPicker name="brandingColour" label="Brand Colour" />
                            )}
                            {values.useCustomTerms && (
                                <Box marginTop={2}>
                                    <InputBaseField
                                        label="Terms & Conditions URL"
                                        name={'termAndConditions'}
                                        placeholder="Terms & Conditions URL"
                                    />
                                </Box>
                            )}

                            <Flex justifyContent={'end'} pt={5} gap={2}>
                                <Button onClick={handleEditModalClose} variant="back-button">
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={
                                        !isValid ||
                                        !(
                                            values.logo ||
                                            (values.useBranding && values.brandingColour) ||
                                            (values.useCustomTerms && values.termAndConditions)
                                        )
                                    }
                                    onClick={submitForm}
                                    variant="main"
                                >
                                    Save
                                </Button>
                            </Flex>
                        </Box>
                    );
                }}
            </Formik>
        </Box>
    );
};
export default LogoUploadModalContent;
